import logo from '../assets/loversconnect-logo.svg';

export default function BrandLogo({ className = 'h-8 w-8', showText = false }) {
  return (
    <div className="flex items-center gap-3">
      <img alt="LoversConnect" className={`${className} object-contain`} src={logo} />
      {showText && (
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-white">
            LoversConnect
          </p>
          <p className="text-[10px] font-medium uppercase tracking-wider text-white/40">
            Admin Portal
          </p>
        </div>
      )}
    </div>
  );
}
